export default {
  getSelectSubject: () => () => {
    const subjectDataSelected = JSON.parse(
      localStorage.getItem("subjectDataSelected") || "{}"
    );
    return subjectDataSelected;
  },
};
